export default "__VITE_ASSET__DVHTmrsx__"